import { render, staticRenderFns } from "./DealerCourseUpload.vue?vue&type=template&id=04aec420&"
import script from "./DealerCourseUpload.vue?vue&type=script&lang=js&"
export * from "./DealerCourseUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports